let VueLog = {}

// Default levels, texts and colors
const _default_severities = {
  FATAL: {value: 0, name: 'FATAL', color: '#E60000', textColor: 'white'},
  ERROR: {value: 3, name: 'ERROR', color: '#E6790C', textColor: 'black'},
  WARNING: {value: 4, name: ' WARN', color: '#E6D517', textColor: 'black'},
  INFO: {value: 6, name: ' INFO', color: '#5CC4E6', textColor: 'black'},
  DEBUG: {value: 7, name: 'DEBUG', color: '#A1CFE6', textColor: 'black'}
}

// Utility _noop
function _noop () {}

// Mock console, for using on browsers with no console
VueLog.console = {
  assert: _noop,
  clear: _noop,
  context: _noop,
  count: _noop,
  countReset: _noop,
  debug: _noop,
  dir: _noop,
  dirxml: _noop,
  error: _noop,
  group: _noop,
  groupCollapsed: _noop,
  groupEnd: _noop,
  info: _noop,
  log: _noop,
  profile: _noop,
  profileEnd: _noop,
  table: _noop,
  time: _noop,
  timeEnd: _noop,
  timeLog: _noop,
  timeStamp: _noop,
  trace: _noop,
  warn: _noop
}

// Vue install method
VueLog.install = function (Vue, options) {
  // defaults option values
  options = Object.assign({
    // should VueLog replace window.console ?
    replace: false,
    // default severity level
    level: 6,
    // default prefix function
    prefix: function (level) {
      let severity = _default_severities.FATAL
      switch (level) {
        case 0:
        case 1:
        case 2:
          severity = _default_severities.FATAL
          break
        case 3:
          severity = _default_severities.ERROR
          break
        case 4:
        case 5:
          severity = _default_severities.WARNING
          break
        case 6:
          severity = _default_severities.INFO
          break
        case 7:
          severity = _default_severities.DEBUG
          break
        default:
          severity = level > 7 ? _default_severities.FATAL : _default_severities.DEBUG
      }

      const loghead = '%c[' + severity.name + ']'
      const textColor = 'display: block; font-weight: bold; color: ' + severity.textColor + '; background-color:' + severity.color

      return [loghead, textColor]
    }
    // merge with input options
  }, options)

  // Merging & storing native window console, if exists
  if (window && window.console) {
    VueLog.console = Object.assign(VueLog.console, window.console)
  }

  // Binding methods. If there is a native counterpart these methods will call that method, preserving native context.
  Vue.$log = {
    assert: VueLog.console.assert.bind(VueLog.console),
    clear:
      VueLog.console.clear.bind(VueLog.console),
    context:
      VueLog.console.context.bind(VueLog.console),
    count:
      VueLog.console.count.bind(VueLog.console),
    countReset:
      VueLog.console.countReset.bind(VueLog.console),
    debug:
      VueLog.console.debug.bind(VueLog.console),
    dir:
      VueLog.console.dir.bind(VueLog.console),
    dirxml:
      VueLog.console.dirxml.bind(VueLog.console),
    group:
      VueLog.console.group.bind(VueLog.console),
    groupCollapsed:
      VueLog.console.groupCollapsed.bind(VueLog.console),
    groupEnd:
      VueLog.console.groupEnd.bind(VueLog.console),
    profile:
      VueLog.console.profile.bind(VueLog.console),
    profileEnd:
      VueLog.console.profileEnd.bind(VueLog.console),
    table:
      VueLog.console.table.bind(VueLog.console),
    time:
      VueLog.console.time.bind(VueLog.console),
    timeEnd:
      VueLog.console.timeEnd.bind(VueLog.console),
    timeLog:
      VueLog.console.timeLog.bind(VueLog.console),
    timeStamp:
      VueLog.console.timeStamp.bind(VueLog.console),
    trace:
      VueLog.console.trace.bind(VueLog.console),

    // logging methods, by levels
    fatal:
      options.level >= _default_severities.FATAL.value
        ? VueLog.console.error.bind(VueLog.console, ...options.prefix(_default_severities.FATAL.value))
        : _noop,
    error:
      options.level >= _default_severities.ERROR.value
        ? VueLog.console.error.bind(VueLog.console, ...options.prefix(_default_severities.ERROR.value))
        : _noop,
    warn:
      options.level >= _default_severities.WARNING.value
        ? VueLog.console.warn.bind(VueLog.console, ...options.prefix(_default_severities.WARNING.value))
        : _noop,
    info:
      options.level >= _default_severities.INFO.value
        ? VueLog.console.log.bind(VueLog.console, ...options.prefix(_default_severities.INFO.value))
        : _noop,
    log:
      options.level >= _default_severities.DEBUG.value
        ? VueLog.console.log.bind(VueLog.console, ...options.prefix(_default_severities.DEBUG.value))
        : _noop
  }

  // $log will be available in both Vue global AND "this" in components
  Vue.prototype.$log = Vue.$log

  // Replacing window.console with Vue.$log
  if (options && options.replace) {
    window.console = Vue.$log
  }
}

export default VueLog



// WEBPACK FOOTER //
// ./src/plugins/logger/logger.js